/**
 * Registry of every Vuex module mounted when the app starts.
 *
 * The key is the namespace the rest of the app uses: `dispatch("room/getAllRooms")`,
 * `mapState("room", …)`, `$store.state.room`. Renaming a key means editing every caller,
 * so keep keys stable and move/rename the folders freely.
 */

// Account & access
import auth from "./auth";

// CRM, communication & operations
import searchHistory from "./search-history";

// Master data, pricing & sales

// Students
import enrolledCourses from "./student/enrolled-courses";

// Curriculum & LMS admin
import curriculumLesson from "./curriculum-lesson";

export default {
  // Account & access
  auth,

  // CRM, communication & operations
  searchHistory,

  // Students
  enrolledCourses,

  // Curriculum & LMS admin
  curriculumLesson,
};
